/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "checkmark-ff30ee72--sprite",
  "use": "checkmark-ff30ee72--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"checkmark-ff30ee72--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><rect width=\"36\" height=\"36\" fill=\"none\" /><path d=\"M1392.25,1441.123l-3.92-3.92a1.5,1.5,0,0,1,2.121-2.121l1.8,1.8,6.607-6.607a1.5,1.5,0,0,1,2.122,2.121Z\" transform=\"translate(-1376.891 -1416.834)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
